import tw from 'twin.macro';

// h-10 / py-2 (not py-3) so a native <Select> is exactly as tall as <Input>, the
// react-select controls and <Button>: filter rows mix all four.
const Select = tw.select`w-full h-10 bg-white rounded-md py-2 px-3 text-gray-500 shadow-md focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500`;

export default Select;
